const humberger = document.querySelector(".tgtp-filter-header__humberger");
const sidebar = document.querySelector(".tgtp-filter-header__sidebar");
const closeSidebar = document.querySelector(".tgtp-filter-header__close-sidebar");

humberger?.addEventListener('click', () => {
  sidebar?.classList.add("open");
  document.body.style.position = "fixed";
});

closeSidebar?.addEventListener('click', () => {
  sidebar?.classList.remove("open");
  document.body.style.position = "";
});

const filterMenuTab = Array.from(document.querySelectorAll(".tgtp-filter-menu__tab-wrapper"));
const filterMenus = Array.from(document.querySelectorAll(".tgtp-filter-menu__filter-menu"));
const spMenu = document.querySelector(".tgtp-filter-header__bottom--sp");
const spMenuInner = document.querySelector(".tgtp-filter-header__sp-menu-list");

filterMenuTab.forEach((tab) => {
  tab.querySelector(".tgtp-filter-menu__tab").addEventListener('click', (e) => {
    filterMenuTab.forEach((tab) => {
      tab.querySelector(".tgtp-filter-menu__filter-menu").classList.remove("active");
      tab.classList.remove("active")
    });
    console.log("test");
    tab.querySelector(".tgtp-filter-menu__filter-menu").classList.add("active");
    tab.classList.add("active");
  });
});

filterMenus.forEach((filterMenu) => {
  const firstMenuTabs = Array.from(filterMenu.querySelector(".tgtp-filter-menu__first-menu").children);
  const secoundMenuTab = Array.from(filterMenu.querySelectorAll(".tgtp-filter-menu__second-menu"));
  const linkList = Array.from(filterMenu.querySelectorAll(".tgtp-filter-menu__third-links"));

  firstMenuTabs.forEach((element) => {
    element.addEventListener('click', () => {
      secoundMenuTab.forEach((menuTab) => {
        menuTab.classList.remove("active");
        const tabs = Array.from(menuTab.querySelectorAll(".tgtp-filter-menu__second-tab"));
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
      });
      linkList.forEach((link) => {
        link.classList.remove("active");
      });
      firstMenuTabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      const index = element.dataset.index;
      filterMenu.querySelector(`.tgtp-filter-menu__second-menu[data-outer-menu="${index}"]`)?.classList.add("active");
      filterMenu.querySelector(`.tgtp-filter-menu__third-links--${index}`)?.classList.add("active");
      element.classList.add("active");
    });
  });

  secoundMenuTab.forEach((menu) => {
    const outerIndex = menu.dataset.outerMenu;
    const tabs = Array.from(menu.querySelectorAll(".tgtp-filter-menu__second-tab"));

    tabs.forEach((element) => {
      element.addEventListener('click', ()=> {
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        linkList.forEach((link) => {
        link.classList.remove("active");
        });

        const index = element.dataset.index;
        filterMenu.querySelector(`.tgtp-filter-menu__third-links--${outerIndex}-${index}`)?.classList.add("active");
        element.classList.add("active");
      });
    });
  });

  const closeBtn = filterMenu.querySelector(".tgtp-filter-menu__close-sp");
  closeBtn?.addEventListener('click', () => {
    filterMenu.classList.remove("active");
    filterMenu.closest(".tgtp-filter-menu__tab-wrapper")?.classList.remove("active");
  });
});

spMenu?.querySelector(".tgtp-filter-header__sp-menu")?.addEventListener('click', () => {
  if (spMenu.classList.contains("active")) {
    spMenu.classList.remove("active");
  } else {
    spMenu.classList.add("active");
  }
});

const pcFilterMenu = Array.from(document.querySelectorAll(".tgtp-filter-header__bottom--pc .tgtp-filter-menu__filter-menu"));

function getCloseMenu(eventTarget, target) {
  if (target.contains(eventTarget)) {
    return false;
  }
  return true;
}

if(pcFilterMenu) {
  document.addEventListener('click', (event) => {
    pcFilterMenu.forEach((element) => {
      if (element.classList.contains("active") && getCloseMenu(event.target, element)) {
        element.classList.remove("active");
        element.closest(".tgtp-filter-menu__tab-wrapper")?.classList.remove("active");
      }
    });
  });
}
